// extracted by mini-css-extract-plugin
module.exports = {"loading":"index_loading_3zsrc","mark":"index_mark_2t4EM","ant-spin":"index_ant-spin_2_Ow6","hide":"index_hide_3C_N7"};